import { createSlice } from "@reduxjs/toolkit";

const initialAdvisorsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  teachersWithBranches: [],
  registrationInfoIds: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const advisorSlice = createSlice({
  name: "advisors",
  initialState: initialAdvisorsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getAdvisors
    advisorsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getTeachers
    teachersFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachers = entities;
    },
    // getTeacherWithBranches
    teachersWithBranchesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachersWithBranches = entities;
    },
    //getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // getRegistrationInfoIds
    registrationInfoIdsFetched: (state, action) => {
      const { isSuccess, type, ids } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.registrationInfoIds = ids;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanRegistrationInfoIds
    registrationInfoIdsCleaned: (state) => {
      state.registrationInfoIds = [];
    },
    //cleanAdvisorsState
    advisorsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});